import React from "react"
import { Link } from "react-router-dom"
import { Trans, useTranslation } from "react-i18next"

function HeadNotification() {
  useTranslation()
  return (
    <div className="notification">
      <p className="uk-margin-remove-bottom">
        <Trans
          i18nKey="home.headnotif"
          components={{
            Link: <Link className="here-link uk-button-text" to="/campaign" />
          }}
        />
      </p>
    </div>
  )
}

export default HeadNotification
